import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./ChangePassword.css";
import FormGuidelines from "../components/FormGuidelines";

export default function ChangePassword() {
  const { changePassword } = useAuth();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);

  const hasMinLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const passwordsMatch = password && password === confirmPassword;

  const isValid = hasMinLength && hasUpperCase && hasLowerCase && hasNumber && passwordsMatch;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!isValid) {
      setError("Please meet all password requirements");
      return;
    }

    setSaving(true);
    try {
      await changePassword(password);
      setSuccess("Password changed successfully!");
      setTimeout(() => navigate("/dashboard"), 1500);
    } catch (err) {
      setError(err?.message || "Failed to change password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="change-password-page">
      <div className="change-password-card">
        <div className="change-password-header">
          <div className="change-password-icon">🔐</div>
          <h2>Change Password</h2>
          <p>Update your account security</p>
        </div>

        <form onSubmit={handleSubmit} className="change-password-form">
          <FormGuidelines />
          {error && (
            <div className="error-message">
              <span>⚠️</span> {error}
            </div>
          )}
          {success && (
            <div className="success-message">
              <span>✓</span> {success}
            </div>
          )}

          <div className="input-group">
            <label>New Password</label>
            <div className="password-input-wrap">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <div className="input-group">
            <label>Confirm Password</label>
            <div className="password-input-wrap">
              <input
                type={showConfirm ? "text" : "password"}
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                {showConfirm ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <div className="password-requirements">
            <h4>Password Requirements</h4>
            <ul>
              <li className={hasMinLength ? "valid" : ""}>
                At least 8 characters
              </li>
              <li className={hasUpperCase ? "valid" : ""}>
                One uppercase letter
              </li>
              <li className={hasLowerCase ? "valid" : ""}>
                One lowercase letter
              </li>
              <li className={hasNumber ? "valid" : ""}>
                One number
              </li>
              <li className={hasSpecialChar ? "valid" : ""}>
                One special character (optional)
              </li>
              <li className={passwordsMatch ? "valid" : ""}>
                Passwords match
              </li>
            </ul>
          </div>

          <button
            type="submit"
            className={`change-password-btn ${saving ? "saving" : ""}`}
            disabled={!isValid || saving}
          >
            {saving ? "Saving..." : "Save Password"}
          </button>

          <button
            type="button"
            className="back-link"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
        </form>
      </div>
    </div>
  );
}